export const SlbCartPageLayout = {
    slots: ['SlbCartContainerSlot'],
};
